const formatDate = (date: Date) => {
  return date.toISOString().split('T')[0] + ' ' + date.toISOString().split('T')[1].split('.')[0];
};

/* create a function which generate a image 64x64 from text and using a palete of colors for backgroud */
const generateAvatar = (text: string, color?: string) => {
  const selectedColor = color || '#ffffff';
  const canvas = document.createElement('canvas');
  canvas.width = 70;
  canvas.height = 70;
  const context = canvas.getContext('2d');
  if (context) {
    context.fillStyle = selectedColor;
    context.fillRect(0, 0, 70, 70);
    context.font = 'bold 24px Arial';
    // depeding on the darkness of the color we will use white or black for the text
    context.fillStyle = defineColorText(selectedColor);
    // center the text
    const textWidth = context.measureText(text).width;
    const x = (canvas.width - textWidth) / 2;
    context.fillText(text, x, 40);
  }
  return canvas.toDataURL();
};

export const defineColorText = (bgColor: string) => {
  const rgb = parseInt(bgColor.slice(1), 16); // convert hex to rgb
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  if (brightness < 125) {
    return '#FFFFFF';
  } else {
    return '#000000';
  }
};

export { formatDate, generateAvatar };
